<template>
  <div class="signup">
    <v-row>
      <v-col class="pa-0">
        <div class="d-flex flex-column align-center mb-5 mt-sm-5">
          <v-img v-if="isLight" class="hidden-xs-only" contain src="/image/login/top_light.png" max-height="260" max-width="100vw"/>
          <v-img v-if="isLight" class="hidden-sm-and-up" contain src="/image/login/top_light_s.png" max-height="260" max-width="100vw"/>
          <v-img v-if="!isLight && !isContinuePeriod" class="hidden-xs-only" contain src="/image/login/top_nssm.jpg" max-height="260" max-width="100vw"/>
          <v-img v-if="!isLight && isContinuePeriod" class="hidden-xs-only" contain src="/image/login/top_nssm_continue.jpg" max-height="260" max-width="100vw"/>
          <v-img v-if="!isLight" class="hidden-sm-and-up" contain src="/image/login/top_nssm_s.jpg" max-height="260" max-width="100vw"/>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="!isProd">
      <v-col cols="12">
        <v-alert
          type="error"
          width="100%"
          style="font-size: 120%"
        >
          こちらは、検証用ページです。実際のご利用は、下記のURLからお進みください。<br/>
          <a href="https://nskenpo.kenchare.net" class="white--text" style="font-size: 140%; word-break: break-all;">https://nskenpo.kenchare.net</a><br/>
          <a href="https://nskenpo.kenchare.net" class="white--text" style="font-size: 140%; word-break: break-all;">
            ⇒ こちらをクリックして本番のキャンペーンサイトにアクセスします。
          </a><br/><br/>
          <p>※ ↓のログインおよびユーザ登録フォームからはご利用できません。</p>
        </v-alert>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        lg="4" offset-lg="4"
        md="6" offset-md="3"
        sm="8" offset-sm="2"
        xs="12"
      >
        <v-card
          class="mx-auto"
          outlined
          elevation="1"
        >
          <v-card-title style="background-color: #ffccd0; color: #ff6673; padding: 0">
            <h5 class="center">新規登録</h5>
          </v-card-title>
          <v-card-text class="pa-5">
            <validation-observer ref="observer">
              <div style="display:flex; flex-wrap:wrap; width:100%">
                <div class="mb-4">
                  健康チャレンジキャンペーンは、毎年ユーザーの登録が必要です。
                </div>
                <v-alert
                  v-if="alert"
                  border="left"
                  colored-border
                  type="error"
                  elevation="2"
                  style="font-size: 90%"
                >
                  {{ error }}
                </v-alert>
                <v-row dense>
                  <v-col cols="12">
                    <v-subheader style="height: 14px" class="text-caption pb-1" >
                      区分を選択
                    </v-subheader>
                  </v-col>
                  <v-btn-toggle
                    v-model="signUpInfo.userClassification"
                    mandatory
                    color="primary"
                    style="margin: 0 auto"
                    class="mb-7"
                  >
                    <v-btn value="本人" width="150" height="35" class="">被保険者（本人）</v-btn>
                    <v-btn value="被扶養者" width="150" height="35" class="">被扶養者（家族）</v-btn>
                  </v-btn-toggle>
                </v-row>
                <v-form @submit.prevent="signUp" ref="form">
                  <v-row dense>
                    <v-col cols="4">
                      <validation-provider
                        name="記号"
                        rules="required|max:4|numeric"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="signUpInfo.userSymbolId"
                          :error-messages="errors"
                          label="記号"
                          type="tel"
                          name="symbol-id"
                          autocomplete="symbol-id"
                          outlined
                          dense
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col class="pt-3 pl-2" cols="1">
                      －
                    </v-col>
                    <v-col cols="7">
                      <validation-provider
                        name="番号"
                        rules="required|max:7|numeric"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="signUpInfo.userNumberId"
                          :error-messages="errors"
                          label="番号"
                          type="tel"
                          name="number-id"
                          autocomplete="number-id"
                          outlined
                          dense
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12">
                      <validation-provider
                        name="パスワード"
                        :rules="{
                          required: true,
                          min: 8,
                          max: 20,
                          regex_password: /^((?=.*[a-zA-Z])(?=.*[0-9])|(?=.*[a-zA-Z])(?=.*[!-/:-@¥[-`{-~])|(?=.*[0-9])(?=.*[!-/:-@¥[-`{-~]))([a-zA-Z0-9!-/:-@¥[-`{-~]){8,}$/
                        }"
                        v-slot="{ errors }"
                        vid="password"
                      >
                        <v-text-field
                          v-model="signUpInfo.password"
                          :append-icon="isShowPassword ? 'mdi-eye' : 'mdi-eye-off'"
                          :error-messages="errors"
                          :type="isShowPassword ? 'text' : 'password'"
                          hint="英字・数字・記号のうち2種以上を含め、8文字以上"
                          persistent-hint
                          @click:append="isShowPassword = !isShowPassword"
                          label="パスワード"
                          name="password"
                          autocomplete="off"
                          outlined
                          dense
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12">
                      <validation-provider
                        name="パスワード"
                        rules="required|confirmed:password"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="signUpInfo.passwordConf"
                          :append-icon="isShowPasswordConf ? 'mdi-eye' : 'mdi-eye-off'"
                          :error-messages="errors"
                          :type="isShowPasswordConf ? 'text' : 'password'"
                          hint="英字・数字・記号のうち2種以上を含め、8文字以上"
                          @click:append="isShowPasswordConf = !isShowPasswordConf"
                          label="パスワード（確認）"
                          name="password"
                          autocomplete="off"
                          outlined
                          dense
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12">
                      <validation-provider
                        name="メールアドレス"
                        rules="required|email"
                        v-slot="{ errors }"
                        vid="email"
                      >
                        <v-text-field
                          v-model="signUpInfo.userEmail"
                          :error-messages="errors"
                          label="メールアドレス"
                          type="email"
                          placeholder="info@sample.com"
                          name="email"
                          autocomplete="email"
                          outlined
                          dense
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12">
                      <validation-provider
                        name="メールアドレス"
                        rules="required|confirmed:email"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="signUpInfo.userEmailConf"
                          :error-messages="errors"
                          label="メールアドレス（確認）"
                          type="email"
                          placeholder="info@sample.com"
                          name="email"
                          outlined
                          dense
                          onpaste="return false"
                        ></v-text-field>
                      </validation-provider>
                      <v-alert
                        border="left"
                        colored-border
                        type="info"
                        elevation="2"
                        style="font-size: 90%"
                      >
                        メールアドレス宛に認証コードを送信します。受信制限されている方は、<b class="red--text">事前に必ず</b>「@kenchare.net」ドメインを受信できるように設定をお願い致します。
                      </v-alert>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12">
                      <v-subheader style="height: 14px" class="text-caption">
                        生年月日
                      </v-subheader>
                    </v-col>
                  </v-row>
                  <v-row dense v-if="!isMobile">
                    <v-col cols="4">
                      <validation-provider
                        name="生年月日(年)"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-select
                          v-model="signUpInfo.birthYear"
                          :items="birthSelectList.year"
                          :error-messages="errors"
                          outlined
                          dense
                        ></v-select>
                      </validation-provider>
                    </v-col>
                    <v-col cols="4">
                      <validation-provider
                        name="生年月日(月)"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-select
                          v-model="signUpInfo.birthMonth"
                          :items="birthSelectList.month"
                          :error-messages="errors"
                          outlined
                          dense
                        ></v-select>
                      </validation-provider>
                    </v-col>
                    <v-col cols="4">
                      <validation-provider
                        name="生年月日(日)"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-select
                          v-model="signUpInfo.birthDay"
                          :items="birthSelectList.day"
                          :error-messages="errors"
                          outlined
                          dense
                        ></v-select>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row dense v-if="isMobile">
                    <v-col cols="12">
                      <validation-provider
                        name="生年月日(年)"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-select
                          v-model="signUpInfo.birthYear"
                          :items="birthSelectList.year"
                          :error-messages="errors"
                          outlined
                          dense
                        ></v-select>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row dense v-if="isMobile">
                    <v-col cols="12">
                      <validation-provider
                        name="生年月日(月)"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-select
                          v-model="signUpInfo.birthMonth"
                          :items="birthSelectList.month"
                          :error-messages="errors"
                          outlined
                          dense
                        ></v-select>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row dense v-if="isMobile">
                    <v-col cols="12">
                      <validation-provider
                        name="生年月日(日)"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-select
                          v-model="signUpInfo.birthDay"
                          :items="birthSelectList.day"
                          :error-messages="errors"
                          outlined
                          dense
                        ></v-select>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row dense v-if="signUpInfo.userClassification=='被扶養者'">
                    <v-col cols="12">
                      <v-subheader style="height: 14px" class="text-caption">
                        性別
                      </v-subheader>
                    </v-col>
                    <v-btn-toggle
                      v-model="signUpInfo.gender"
                      mandatory
                      color="primary"
                      style="margin: 0 auto"
                    >
                      <v-btn width="100" height="30" value="male">男性</v-btn>
                      <v-btn width="100" height="30" value="female">女性</v-btn>
                    </v-btn-toggle>
                  </v-row>
                  <v-row dense v-if="isShowPepUpKeyword">
                    <v-col cols="12">
                      <validation-provider
                        name="PepUpキーワード"
                        :rules="isShowPepUpKeyword ? 'required|pepup_keyword' : ''"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="signUpInfo.pepUpKeyword"
                          :error-messages="errors"
                          label="PepUpキーワード"
                          hint="健保より配信されているキーワードを入力してください。"
                          persistent-hint
                          name="pepup-keyword"
                          autocomplete="off"
                          outlined
                          dense
                        ></v-text-field>
                      </validation-provider>
                      <v-alert
                        border="left"
                        colored-border
                        type="info"
                        elevation="2"
                        style="font-size: 90%"
                      >
                        PepUpキーワードは、PepUpログイン後のトップページに表示されます。<br/>
                        ※PepUpの登録は<a href="https://www.kenpo.gr.jp/nskenpo/contents/hoken/pepup/tetuduki.html" target="_blank">こちら</a>
                      </v-alert>
                    </v-col>
                  </v-row>
                  <div class="center">
                    <v-btn
                      type="submit"
                      color="primary"
                      class="mt-5"
                      :loading="isLoading"
                    >
                      ユーザー登録
                    </v-btn>
                  </div>
                </v-form>
              </div>
            </validation-observer>
            <div class='authlinks mt-10 text-left'>
              <v-btn text color="primary" @click="signIn">
                ログイン画面に戻る
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Vue from 'vue'
import AmplifyEventBus from './AmplifyEventBus'
import { Auth, I18n } from 'aws-amplify'
import { v4 as uuidv4 } from 'uuid'
import { translate } from '@/i18n'
import { required, max, min, numeric, confirmed, email, regex } from 'vee-validate/dist/rules'
import { localize, extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import ja from 'vee-validate/dist/locale/ja.json'
import dayjs from 'dayjs'

// PepUpキーワード（小文字で記載）
const PEPUP_KEYWORD = 'phr'
// PepUpキーワード項目の非表示開始日時（この日時以降は項目を非表示にし、入力不可とする）
const PEPUP_KEYWORD_HIDE_AT = dayjs('2026-10-21T00:00:00')

// バリデーションの定義
setInteractionMode('eager')
localize('ja', ja)
extend('required', required)
extend('max', max)
extend('min', min)
extend('numeric', numeric)
extend('confirmed', confirmed)
extend('email', email)
extend('regex_password', {
  ...regex,
  message: '{_field_}は英字・数字・記号のうち2種以上を含めてください'
})
// PepUpキーワード（半角・全角、大文字・小文字を問わず許容）
extend('pepup_keyword', {
  validate (value) {
    if (value === null || value === undefined) return false
    return String(value).normalize('NFKC').trim().toLowerCase() === PEPUP_KEYWORD
  },
  message: '{_field_}が誤っています。PepUpにて「健保からのお知らせ」欄をご確認ください。'
})

export default Vue.extend({
  name: 'HCSignUp',
  props: ['signUpConfig'],
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data () {
    return {
      signUpInfo: {
        userClassification: '本人',
        userSymbolId: '',
        userNumberId: '',
        userEmail: '',
        userEmailConf: '',
        password: '',
        passwordConf: '',
        birthYear: '',
        birthMonth: '',
        birthDay: '',
        gender: '',
        pepUpKeyword: ''
      },
      isShowPassword: false,
      isShowPasswordConf: false,
      birthSelectList: {
        year: [],
        month: [],
        day: []
      },
      isLoading: false,
      error: '',
      logger: {},
      alert: false,
      isContinuePeriod: false
    }
  },
  computed: {
    options () {
      const defaults = {
        header: I18n.get('Sign In Account'),
        username: '',
        isSignUpDisplayed: true
      }
      return Object.assign(defaults, this.signUpConfig || {})
    },
    // 運用テストかどうか（健チャレLight版）
    isLight () {
      return process.env.VUE_APP_IS_LIGHT
    },
    isProd () {
      return process.env.VUE_APP_DISP_STAGE_NAME === 'prod'
    },
    isMobile () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return true
        case 'sm': return true
        case 'md': return false
        case 'lg': return false
        case 'xl': return false
      }
      return false
    },
    // PepUpキーワード項目の表示可否（本人 かつ 非表示開始日時より前のときのみ表示）
    isShowPepUpKeyword () {
      return this.signUpInfo.userClassification === '本人' && dayjs() < PEPUP_KEYWORD_HIDE_AT
    }
  },
  watch: {
    'signUpInfo.birthYear' () {
      this.getBirthDaySelectList()
    },
    'signUpInfo.birthMonth' () {
      this.getBirthDaySelectList()
    }
  },
  created () {
    // 18歳～75歳が対象
    const todayYear = dayjs().year()
    const yearSelectList = []
    for (let y = todayYear - 76; y <= todayYear - 18; y++) {
      yearSelectList.push({ text: y + '年', value: y })
    }
    this.birthSelectList.year = yearSelectList.reverse()
    for (let m = 1; m <= 12; m++) {
      this.birthSelectList.month.push({ text: m + '月', value: m })
    }
    this.signUpInfo.birthYear = this.birthSelectList.year[0].value
    this.signUpInfo.birthMonth = 1
    this.signUpInfo.birthDay = 1
  },
  mounted () {
    this.getCampaignJson()
  },
  methods: {
    // cloudfront→S3からjsonファイルのキャンペーン参加者人数を取得
    getCampaignJson () {
      const url = process.env.VUE_APP_CAMPAIGNLIST_URL + '/campaign_list.json'
      var xmlHttpRequest = new XMLHttpRequest()
      xmlHttpRequest.open('GET', url, true)
      xmlHttpRequest.responseType = 'json'
      xmlHttpRequest.send(null)
      const me = this
      xmlHttpRequest.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
          if (this.response) {
            const campaignList = this.response
            const conTargetCampaign = campaignList.find(item => item.is_continuity)
            if (conTargetCampaign) {
              // トップ画像の表示分け
              me.isContinuePeriod = dayjs(conTargetCampaign.start, 'YYYY-MM-DD') < dayjs()
            }
          }
        }
      }
    },
    getBirthDaySelectList () {
      const targetDate = `${this.signUpInfo.birthYear}-${this.signUpInfo.birthMonth}-01`
      const maxDay = dayjs(targetDate, 'YYYY-MM-DD').endOf('month').date()
      this.birthSelectList.day = []
      for (let d = 1; d <= maxDay; d++) {
        this.birthSelectList.day.push({ text: d + '日', value: d })
      }
    },
    async signUp (e) {
      this.alert = false
      this.isLoading = true
      const isValidateError = await this.$refs.observer.validate()
      if (!isValidateError) {
        this.toPageTop()
        this.alert = true
        this.error = '入力内容にエラーがあります。確認してください。'
        this.isLoading = false
        return false
      }
      const certificateNumber = `${this.signUpInfo.userSymbolId}-${this.signUpInfo.userNumberId}`
      const user = {
        username: uuidv4(),
        attributes: {},
        password: this.signUpInfo.password
      }
      user.attributes.email = this.signUpInfo.userEmail
      user.attributes['custom:certificate_number'] = certificateNumber
      const birthMonth = `0${this.signUpInfo.birthMonth}`.slice(-2)
      const birthDay = `0${this.signUpInfo.birthDay}`.slice(-2)
      user.attributes.birthdate = `${this.signUpInfo.birthYear}-${birthMonth}-${birthDay}`
      if (this.signUpInfo.userClassification === '本人') {
        user.attributes['custom:user_classification'] = '本人'
      } else if (this.signUpInfo.userClassification === '被扶養者') {
        user.attributes['custom:user_classification'] = '被扶養者'
        user.attributes.gender = this.signUpInfo.gender
      } else {
        this.error = `${translate('auth.errors.unexpectedError')}`
        return
      }
      Auth.signUp(user)
        .then(async (data) => {
          this.$log.info('sign up success')
          AmplifyEventBus.$emit('localUser', data.user)
          if (data.userConfirmed === false) {
            return AmplifyEventBus.$emit('authState', 'confirmSignUp')
          }
          return AmplifyEventBus.$emit('authState', 'signIn')
        })
        .catch((e) => {
          this.$log.debug('---error signup----:', e)
          this.toPageTop()
          if (e.code && e.code === 'UserNotConfirmedException') {
            AmplifyEventBus.$emit('localUser', { username: this.options.username })
            AmplifyEventBus.$emit('authState', 'confirmSignUp')
            return false
          } else {
            this.setError(e)
          }
        })
    },
    signIn () {
      AmplifyEventBus.$emit('authState', 'signIn')
    },
    setError (e) {
      this.isLoading = false
      const errorMessage = I18n.get(e.message || e)
      this.$log.error(errorMessage)
      if (errorMessage === 'Incorrect username or password.') {
        this.error = `${translate('auth.errors.incorrectIdOrPass')}`
      } else if (errorMessage === 'PreSignUp failed with error User not exist on Enrollment list.') {
        this.error = `${translate('auth.errors.userNotExist')}`
      } else if (errorMessage === 'PreSignUp failed with error email already registered.') {
        this.error = `${translate('auth.errors.userEmailiAlreadyExist')}`
      } else if (errorMessage === 'PreSignUp failed with error preffered_username already registered.') {
        this.error = `${translate('auth.errors.userAlreadyExist')}`
      } else {
        this.error = `${translate('auth.errors.unexpectedError')}`
      }
      this.alert = true
    },
    toPageTop () {
      const interval = 25 // 0.025秒ごとに移動
      const step = -window.scrollY / Math.ceil(200 / interval) // 1回に移動する距離
      const timer = setInterval(() => {
        window.scrollBy(0, step)
        if (window.scrollY <= 0) {
          clearInterval(timer)
        }
      }, interval)
    }
  }
})
</script>

<style scoped lang="scss">
.signup {
  .center {
    margin: 5px auto;
    text-align: center;
  }
}
.authlinks {
  display: block;
  margin-top:10px;
}
button.ma-2.clbtn-main.v-btn.v-item--active.v-btn--active.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default {
  background-color: #8AD0B0 !important;
}
button.ma-2.clbtn-main.v-btn.v-item--active.v-btn--active.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default::before {
  opacity: 0 ;
}
button.ma-2.clbtn-dependent.v-btn.v-item--active.v-btn--active.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default {
  background-color: #ffed66 !important;
}
button.ma-2.clbtn-dependent.v-btn.v-item--active.v-btn--active.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default::before {
  opacity: 0 ;
}
</style>
